export default class Decision {
    id:number = 1;
    decision:string = "";
    outcome:string = "None";
    impact:string = "Tiny";
    shouldJump:boolean = false;
    jumpPage:string = "1";
    jumpChapter:string = "1";
    move:string = "Continue";
}



// WEBPACK FOOTER //
// ./src/objects/Decision.ts